import { useSearchParams } from "react-router-dom";
import { useShop } from "../context/ShopContext";
import { PerfumeCard } from "./PerfumeCard";
import { Reveal, MaskLine } from "./Reveal";

export const Catalog = () => {
  const { perfumes, collections } = useShop();
  const [params, setParams] = useSearchParams();
  const active = params.get("collection") || "toutes";
  const list = active === "toutes" ? perfumes : perfumes.filter((p) => (p.collections || []).includes(active));
  const tabs = [{ slug: "toutes", name: "Toutes" }, ...collections];

  return (
    <section className="bg-ivory pb-28 pt-32 sm:pt-40">
      <div className="wrap">
        <Reveal>
          <p className="eyebrow flex items-center gap-4 text-champagne">
            <span className="h-px w-10 bg-champagne" />
            La collection
          </p>
        </Reveal>
        <MaskLine className="mt-5">
          <h1 className="font-serif text-5xl leading-[1.02] text-espresso sm:text-6xl">
            Parfums <em className="italic text-taupe">d'exception</em>
          </h1>
        </MaskLine>
        <Reveal delay={0.15}>
          <p className="mt-5 max-w-md text-[15px] leading-relaxed text-espresso/70">
            Une sélection raffinée pour elle et pour lui. Prix affichés hors frais de livraison.
          </p>
        </Reveal>

        <Reveal delay={0.2} className="mt-10 flex flex-wrap gap-3">
          {tabs.map((t) => (
            <button
              key={t.slug}
              data-testid={`filter-tab-${t.slug}`}
              onClick={() => setParams(t.slug === "toutes" ? {} : { collection: t.slug })}
              className={`rounded-full border px-5 py-2.5 text-[10px] uppercase tracking-[0.22em] transition-all duration-300 ${
                active === t.slug
                  ? "border-espresso bg-espresso text-ivory"
                  : "border-espresso/20 text-espresso/70 hover:border-espresso/60 hover:text-espresso"
              }`}
            >
              {t.name}
            </button>
          ))}
        </Reveal>

        <p className="mt-6 text-[11px] uppercase tracking-[0.25em] text-taupe" data-testid="catalog-count">
          {list.length} {list.length > 1 ? "créations" : "création"}
        </p>

        {list.length ? (
          <div className="mt-6 grid grid-cols-2 gap-x-5 gap-y-12 lg:grid-cols-3 xl:grid-cols-4">
            {list.map((p, i) => (
              <PerfumeCard key={p.id || p.slug} p={p} index={i} />
            ))}
          </div>
        ) : (
          <div className="mt-20 flex flex-col items-center gap-4 text-center">
            <span className="font-serif text-5xl text-taupe/40">V</span>
            <p className="font-serif text-2xl italic text-espresso/60">
              Aucune création dans cette collection pour le moment.
            </p>
          </div>
        )}
      </div>
    </section>
  );
};
